import { GET, POST, PUT } from "./api.js";

export const notificationApi = {
    getNoti: (id) => GET(`/notification/${id}`),
    read: (id) => PUT(`/notification/markAsRead/${id}`)
};
